import { Button, Card, Checkbox, Col, Input, notification, Row } from "antd";
import React, { useEffect, useState } from "react";
import { withRouter } from "../../../../../utils/tms-with-router/tms-with-router";
import "../../../../../assets/css/tms-darshanam/tms-d-inner-pages-and.scss";
import catchErrorFunction from "../../../../../utils/tms-catch-error/tms-catch-error";
import TmsImageUpload from "../../../../../components/tms-customs/tms-image-upload";
import TmsShivaDeekshaService from "../../../../../services/shiva-deeksha.service";

const ShivaDeekshaInnerPagesAND = ({
  viewShivaDeekshaData,
  editFlag,
  productId,
  setEditFlag,
  settmsModalVisible,
  router,
}) => {
  const { TextArea } = Input;
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState("");
  const [description, setdescription] = useState("");
  const [counterEnabled, setcounterEnabled] = useState(false);
  const [onlineEnabled, setonlineEnabled] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [changeRequestFile, setChangeRequestFile] = useState([]);
  const [changeRequestDesc, setChangeRequestDesc] = useState("");

  const fetchData = async () => {
    setLoading(true);
    if (
      name === "" ||
      description === "" ||
      counterEnabled === "" ||
      onlineEnabled === "" ||
      fileList?.length === 0
    ) {
      notification.error({ message: "Please enter all the details" });
      setLoading(false);
      return;
    }
    if (editFlag) {
      if (changeRequestFile?.length === 0 || changeRequestDesc === "") {
        notification.error({ message: "Fill all the fields" });
        setLoading(false);

        return;
      }
    }
    try {
      let body = {
        name: name,
        description: description,
        counterEnabled: counterEnabled,
        onlineEnabled: onlineEnabled,
        imageUrl: fileList[0]?.url,
        "X-Temple-Id": localStorage.getItem("templeId"),
      };
      if (editFlag) {
        body.changeRequestPdfUrl = changeRequestFile[0].url;
        body.changeDescription = changeRequestDesc;
      }
      if (editFlag) {
        await TmsShivaDeekshaService.editShivaDeeksha(productId, body);
        // setDarshanamData(darData);
        notification.success({ message: "Bhavani Deeksha Edited Successful" });
        setEditFlag(false);
      } else {
        await TmsShivaDeekshaService.createShivaDeeksha(body);
        // setDarshanamData(data?.items);
        notification.success({ message: "Bhavani Deeksha Created Successful" });
        handleFuction();
      }
      setLoading(false);
    } catch (error) {
      catchErrorFunction(
        error,
        "Token Expired, redirecting to login page in 5 seconds",
        router
      );
      setLoading(false);
    }
  };

  const handleFuction = () => {
    setName("");
    setdescription("");
    setcounterEnabled(false);
    setonlineEnabled(false);
    setFileList([]);
    setChangeRequestFile([]);
    setChangeRequestDesc("");
  };

  useEffect(() => {
    if (editFlag) {
      setName(viewShivaDeekshaData?.name);
      setdescription(viewShivaDeekshaData?.description);
      setcounterEnabled(viewShivaDeekshaData?.counterEnabled);
      setonlineEnabled(viewShivaDeekshaData?.onlineEnabled);
      setFileList([{ url: viewShivaDeekshaData?.imageUrl, status: "done" }]);
    }
  }, [viewShivaDeekshaData]);

  return (
    <Row className="formRow" style={{ width: "100%" }}>
      <Card style={{ width: "100%" }}>
        <Row className="formRow">
          <label className="formLabel">Bhavani Deeksha Nam</label>
          <Input
            maxLength={220}
            className="formInput"
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </Row>

        <Row className="formRow">
          <label className="formLabel">Description</label>
          <TextArea
            maxLength={2000}
            className="formInput"
            rows={4}
            value={description}
            onChange={(e) => setdescription(e.target.value)}
          />
        </Row>
        <Row gutter={[20, 20]} className="formRow">
          <Col className="formCols-2 contantCenter">
            <label style={{ paddingRight: "10px" }}>Enable POS</label>
            <Checkbox
              style={{ paddingRight: "10px" }}
              checked={counterEnabled}
              onChange={(e) => setcounterEnabled(e.target.checked)}
            />
            <label style={{ paddingRight: "10px" }}>Enable Online</label>
            <Checkbox
              checked={onlineEnabled}
              onChange={(e) => setonlineEnabled(e.target.checked)}
            />
          </Col>
        </Row>

        <Row className="formRow">
          <label className="formLabel">Image</label>
          <TmsImageUpload
            fileList={fileList}
            setFileList={setFileList}
            router={router}
          />
        </Row>
        {editFlag && (
          <>
            <Row gutter={[20, 20]} className="formRow">
              <label className="formLabel">Request Copy</label>
              <Col className="formInput ">
                <TmsImageUpload
                  fileList={changeRequestFile}
                  setFileList={setChangeRequestFile}
                  router={router}
                  type="private"
                  accept={true}
                  className="w-100"
                />
              </Col>
            </Row>
            <Row className="formRow">
              <label className="formLabel">Edit Description</label>
              <Input
                maxLength={220}
                className="formInput"
                value={changeRequestDesc}
                onChange={(e) => setChangeRequestDesc(e.target.value)}
              />
            </Row>
          </>
        )}
        <Row gutter={[20, 20]}>
          <Col span={5}></Col>
          <Col className="formCols-2 buttonPad">
            <Button
              className="formButton"
              type="default"
              loading={loading}
              onClick={() => {
                editFlag ? settmsModalVisible(false) : handleFuction();
              }}
            >
              {editFlag ? "Return" : "Clear"}
            </Button>
          </Col>
          <Col className="formCols-2 buttonPad">
            <Button
              className="formButton"
              type="primary"
              loading={loading}
              onClick={() => {
                fetchData();
              }}
            >
              Submit
            </Button>
          </Col>
        </Row>
      </Card>
    </Row>
  );
};

export default withRouter(ShivaDeekshaInnerPagesAND);
